import styled from 'styled-components';
import { BasicButton } from '../../../component/button';
import { pxToRem } from '../../../utils/pxToRem';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 120px;
`;
export const Title = styled.p`
  font-family: DM Sans;
  font-size: ${pxToRem(21)};
  font-style: normal;
  font-weight: 500;
  line-height: ${pxToRem(29)};
  letter-spacing: 0.15000000596046448px;
  text-align: left;
`;
export const AddBtn = styled(BasicButton)`
  width: 120px;
  padding: 11px 0px;
  border-radius: 8px;
`;
export const SortContainer = styled.div`
  align-self: flex-end;
  display: flex;
  align-items: center;
  margin-top: 61px;
`;
export const SortText = styled(Title)`
  margin-right: 16px;
`;
export const ListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 48px;
`;
